export const ALL_GAME = [
  // Card games
  { id: 1,  name: "Tiến Lên", code: "TLMN", type: "card" },
  { id: 2,  name: "Mậu Binh", code: "MB", type: "card" },
  { id: 3,  name: "Poker", code: "POKER", type: "card" },
  { id: 4,  name: "Xì Dách", code: "XD", type: "card" },
  { id: 5,  name: "Bài Cào", code: "CAO", type: "card" },
  { id: 7,  name: "Liêng", code: "LIENG", type: "card" },
  { id: 8,  name: "Sâm", code: "SAM", type: "card" },
  { id: 21, name: "Poker Mini", code: "POKER_MINI", type: "card" },
  { id: 24, name: "Black Jack", code: "BLACKJACK", type: "card" },

  // Casino & live casino
  { id: 6,  name: "Xóc Đĩa", code: "XD", type: "casino" },
  { id: 9,  name: "Xóc Đĩa", code: "XOC_DIA", codeBank: "XOCDIA", type: "casino" },
  { id: 10, name: "Bầu Cua", code: "BAU_CUA", type: "casino" },
  { id: 13, name: "Xóc Đĩa", code: "XOC_DIA_TL", type: "casino" },
  { id: 14, name: "Tài Xỉu Mini Jackpot", code: "TAIXIU_MINI_JP", type: "casino" },
  { id: 17, name: "Tài Xỉu Mini MD5", code: "TAIXIU_MINI_MD5", type: "casino" },
  { id: 18, name: "Tai Xiu Sicbo", code: "SICBO", type: "casino" },
  { id: 19, name: "Baccarat", code: "BACCARAT", type: "casino" },
  { id: 20, name: "Tài Xỉu Mini", code: "TAIXIU_MINI", type: "casino" },
  { id: 22, name: "Cao Thấp", code: "UPDOWN_MINI", type: "casino" },
  { id: 60, name: "Roulette", code: "ROULETTE", type: "casino" },
  { id: 62, name: "Poker Mega", code: "POKER_MEGA", type: "casino" },
  { id: 63, name: "Lô Đề Siêu Tóc", code: "LODE_SIEUTOC", type: "casino" },
  { id: 64, name: "Tài Xỉu Live", code: "TAIXIU_LIVE", type: "casino" },
  { id: 65, name: "Xóc Đĩa Live", code: "XOCDIA_LIVE", type: "casino" },
  { id: 66, name: "Xóc Đĩa 88 Live", code: "XOCDIA88_LIVE", type: "casino" },
  { id: 67, name: "Xóc Đĩa Hit Live", code: "XOCDIAHIT_LIVE", type: "casino" },
  { id: 70, name: "Tài Xỉu Mini Live", code: "TAIXIU_MINI_LIVE", type: "casino" },
  { id: 73, name: "Xóc Đĩa 789 Live", code: "XOCDIA789_LIVE", type: "casino" },
  { id: 74, name: "Xóc Đĩa BOC Live", code: "XOCDIABOC_LIVE", type: "casino" },
  { id: 75, name: "Baccarat BOC Live", code: "BACCARATBOC_LIVE", type: "casino" },
  { id: 76, name: "Tài Xỉu KUBET Live", code: "TAIXIUKUBET_LIVE", type: "casino" },
  { id: 77, name: "Poker Mega SG", code: "POKER_MEGA_SG", type: "casino" },
  { id: 78, name: "Roulette Sun", code: "ROULETTE_SUN", type: "casino" },
  { id: 79, name: "Sun Rồng", code: "SUN_RONG", type: "casino" },

  // Slot games
  { id: 16, name: "Slot Mini", code: "SLOTMINI", type: "slot" },
  { id: 90, name: "Slot Wukong", code: "SLOT_WUKONG", type: "slot" },
  { id: 91, name: "Slot DaoCa", code: "SLOT_DAOCA", type: "slot" },
  { id: 92, name: "Slot ThuyCung", code: "SLOT_THUY_CUNG", type: "slot" },
  { id: 93, name: "Slot KhoTangNguLong", code: "SLOT_KHOTANNGULONG", type: "slot" },
  { id: 94, name: "Slot PhaCoDenRong", code: "SLOT_PHACODENRONG", type: "slot" },
  { id: 95, name: "Slot Samurai", code: "SLOT_SAMURAI", type: "slot" },
  { id: 100, name: "Slot MetaGear", code: "SLOT_METAGEAR", type: "slot" },
  { id: 101, name: "Slot GodOfWar", code: "SLOT_GODOFWAR", type: "slot" },
  { id: 102, name: "Slot Lady", code: "SLOT_LADY", type: "slot" },
  { id: 103, name: "Slot KỳLân", code: "SLOT_KYLAN", type: "slot" },
  { id: 104, name: "Slot Avenger", code: "SLOT_AVENGER", type: "slot" },
  { id: 105, name: "Slot PirateKing", code: "SLOT_PIRATE_KING", type: "slot" },
  { id: 106, name: "Slot ThầnTài", code: "SLOT_THAN_TAI", type: "slot" },
  { id: 107, name: "Slot STTT", code: "SLOT_STTT", type: "slot" },
  { id: 108, name: "Slot WorldDance", code: "SLOT_WORLDDANCE", type: "slot" },
  { id: 109, name: "Slot Halloween", code: "SLOT_HALLOWEEN", type: "slot" },
  { id: 110, name: "Slot TayDuKy", code: "SLOT_TAYDUKY", type: "slot" },
  { id: 111, name: "Slot CayKhe", code: "SLOT_CAYKHE", type: "slot" },
  { id: 112, name: "Slot CungHyPhatTai", code: "SLOT_CUNGHYPHATTAI", type: "slot" },
  { id: 113, name: "Slot TheWicher", code: "SLOT_THEWICHER", type: "slot" },
  { id: 114, name: "Slot OngDo", code: "SLOT_ONGDO", type: "slot" },
  { id: 115, name: "Slot LuckyLuck", code: "SLOT_LUCKKYLUCK", type: "slot" },
  { id: 116, name: "Slot BatTienQuaHai", code: "SLOT_BATTIENQUAHAI", type: "slot" },
  { id: 117, name: "Slot FastAndFurious", code: "SLOT_FASTANDFURIOUS", type: "slot" },
  { id: 118, name: "Slot SieuSaoWC", code: "SLOT_SIEUSAOWC", type: "slot" },
  { id: 119, name: "Slot XinXam", code: "SLOT_XINXAM", type: "slot" },
  { id: 120, name: "Slot BáTước", code: "SLOT_BATUOC", type: "slot" },
  { id: 121, name: "Slot NaTra", code: "SLOT_NATRA", type: "slot" },
  { id: 122, name: "Slot TứLinh", code: "SLOT_TULINH", type: "slot" },
  { id: 123, name: "Slot Đế Chế", code: "SLOT_AOE", type: "slot" },
  { id: 124, name: "Slot MeoTaiLoc", code: "SLOT_MEO_TAI_LOC", type: "slot" },
  { id: 125, name: "Slot SacXuanChoTet", code: "SLOT_SAC_XUAN_CHO_TET", type: "slot" },
  { id: 126, name: "Slot CLEOPATRA", code: "SLOT_CLEOPATRA", type: "slot" },
  { id: 130, name: "Slot ICE", code: "SLOT_ICE", type: "slot" },
  { id: -80, name: "Slot ThanKhi", code: "SLOT_THANKHI", type: "slot" },

  // Fishing
  { id: 50, name: "Bắn Cá", code: "BAN_CA", type: "fishing" },
  { id: 51, name: "Bắn Cá", code: "BAN_CA_B52", type: "fishing" },
  { id: 52, name: "Bắn Cá", code: "BAN_CA_RIKVIP", type: "fishing" },
  { id: 53, name: "Bắn Cá", code: "BAN_CA_GO88", type: "fishing" },
  { id: 50, name: "Bắn Cá Sunwin", code: "BAN_CA_SUNWIN", type: "fishing" },

  // Event
  { id: 11, name: "Worldcup", code: "WORLDCUP", type: "event" },
  { id: 12, name: "Ngũ Quả", code: "NGUQUA", type: "event" },

  // Sport
  { id: 45, name: "Sport", code: "SPORT", type: "sport" },

  // Other
  { id: 61, name: "Máy Bay", code: "MAY_BAY", type: "other" },
];


export const GAME_TYPES = [
  {
    value: 'table',
    label: 'Card game'
  },
  {
    value: 'fishing',
    label: 'Game cá'
  },
  {
    value: 'slot',
    label: 'Game slot'
  },
  {
    value: 'other',
    label: 'Game khác'
  }
]

// Lấy item theo type
export function getGamesByType(type) {
  return ALL_GAME.filter(game => game.type === type);
}

// Các hàm tiện lợi cho từng loại
export function getCardGames() {
  return getGamesByType("card");
}

export function getBetGames() {
  return getGamesByType("casino");
}

export function getFishingGames() {
  return getGamesByType("fishing");
}

export function getSlotGames() {
  return getGamesByType("slot");
}

export function getOtherGames() {
  return getGamesByType("other");
}
